import React from "react";
import BorderedSelect from "../../../../atoms/Inputs/BorderedSelect";

const PageSelect: React.FC<{ value: number; onPageSizeChanged: any }> = ({
  onPageSizeChanged,
  value,
}) => {
  return (
    <div style={{ width: "72px" }}>
      <BorderedSelect
        onChange={(e) => onPageSizeChanged(e)}
        value={value}
        selectArray={[
          { id: 1, value: 10 },
          { id: 2, value: 20 },
          { id: 3, value: 30 },
        ]}
      />
    </div>
  );
};
export default PageSelect;
